<style scoped>
.symbol-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 18px;
  color: var(--color-text-light);
}

.box1 {
  /*padding-top: 20px;*/
  /*padding-bottom: 30px;*/
  /*padding-left: 20px;*/
  /*padding-right: 20px;*/
  /*margin-top: 10px;*/
  /*width: 440px*/
}

.text-cell {
  /* width: 120px; */
  text-align: left;
  height: 35px;
  font-size: 14px;
  color: var(--color-neutral-light);
}

.value-cell {
  text-align: right;
  width: 180px;
}

.input {
  /*width: 34px;*/
  font-size: 13px;
}

.err-text {
  font-size: 12px;
  color:var(--color-danger-light);
}

.err-text14 {
  font-size: 14px;
  color:var(--color-danger-light);
  margin-top: 10px;
  margin-bottom: 5px;
}

.warn-text14 {
  font-size: 14px;
  color: var(--color-warning);
  margin-top: 10px;
  margin-bottom: 5px;
}

.err-cell {
  height: 10px;
  margin-top: -12px;
  text-align: right;
}

.hint-icon {
  color: var(--color-neutral-light);
  padding-bottom: 3px;
}

.toggle-cell {
  padding-right: 10px;
}

.free-balance-text {
  font-size: 11px;
  color: var(--color-text-dark);
  font-weight: bold;
}

.clsbtn {
  color: var(--color-text-dark);
}

.clsbtn:hover {
  color: var(--color-neutral-light);
}

.amount-percent {
  font-size: 12px;
  cursor: pointer;
  padding-left: 6px;
  color: var(--color-accent-dark);
}

.amount-percent:hover {
  text-decoration: underline;
}

.accum {
  font-size: 12px;
}

td {
  /* border: 1px solid #404364; */
  /* border: 1px solid red; */
}

div {
  /* border: 1px solid yellow; */
}

.grid-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 11px;
}

.grid-info-label {
  color: var(--color-text-dark);
  font-weight: normal;
}

.grid-info-value {
  color: var(--color-text-light);
  font-weight: bold;
}

.grid-info-combined {
  display: flex;
  gap: 20px;
  margin-bottom: 8px;
}

.grid-info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.grid-info-item .grid-info-label {
  font-size: 10px;
  color: var(--color-text-dark);
  font-weight: normal;
  margin-bottom: 2px;
  text-align: center;
}

.grid-info-item .grid-info-value {
  font-size: 12px;
  color: var(--color-text-light);
  font-weight: bold;
  text-align: center;
}

.simulation-panel {
  background: var(--color-bg-light);
}

.sim-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.sim-info {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sim-label {
  font-size: 11px;
  color: var(--color-text-dark);
  font-weight: normal;
}

.sim-value {
  font-size: 12px;
  color: var(--color-text-light);
  font-weight: bold;
}

.sim-profit-positive {
  color: var(--color-success);
}

.sim-profit-negative {
  color: var(--color-danger-light);
}
</style>

<template>
  <div>
    <GridOrdersModal
      :show="botOrdersModalShow"
      :orders="botOrders"
      :botName="bot.Name"
      :symbol="bot.Symbol"
      @on-cancel="botOrdersModalShow = false"
    />
    <div
      class="box symbbox"
      style="height: 100%; padding: 10px 10px; display: flex; flex-direction: column;"
    >
      <!-- Header Table: Symbol Chooser and Balance -->
      <table style="width: 100%; border-spacing: 0; margin-bottom: 5px;">
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >
            <SymbolsChooser
              v-if="!bot.Id"
              v-model="symbol"
              :symbols="botSymbols"
              @click="selectSymbol"
              botsStyle
            />
            <div v-else>
              <div class="symbol-wrapper">
                <CoinIcon :symbol="symbol" />
                <span>{{ symbol }}</span>
                <Icon
                  style="cursor: pointer;"
                  :title="$text.tr('Показать сделки')"
                  type="ios-list-box-outline"
                  color="var(--color-text-dark)"
                  @click="getBotOrders()"
                ></Icon>
              </div>
              <div style="font-size: 12px; color: var(--color-text-dark); cursor: pointer" @click="$copyToClipboardAndNotify(bot.Id)">#{{ bot.Id }}</div>
            </div>
          </td>
          <td
            class="value-cell"
            style="vertical-align: bottom; padding-bottom: 8px;"
          >
            <div class="free-balance-text">{{ $text.tr('ДОСТУПНО') }}</div>
            <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ balanceTrunc.toString() }} {{ currency }}</div></div>
          </td>
        </tr>
      </table>

      <!-- Main Form Table -->
      <table style="width: 100%; border-spacing: 0;">
        <tr>
          <td
            colspan="3"
            class="text-cell"
          >
          <div class="futures-panel__right" style="display: flex;  justify-content: space-between; align-items: center; flex-basis: 80%;">
          <Icon @click="leverageClicked(-1)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer; margin-right: 5px"
                    type="md-remove"
                    size="20"
                  ></Icon>
          <template>
            <Slider
              class="futures-panel__leverage-slider"
              v-model="eb.leverage"
              @on-input="leverageDragged"
              @on-change="leverageChanged"
              :min="1"
              :max="maxLeverage"
              :step="1"
              show-tip="never"
              style="width: 25%;"
            >
            </Slider>
            <Icon @click="leverageClicked(1)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer; margin-left: 5px"
                    type="md-add"
                    size="20"
                  ></Icon>
            <span style="min-width: 30px; margin-left: 10px;">
              <b>{{ eb.leverage }}X</b>
            </span>
            <RadioGroup
              class="flex"
              type="button"
              size="small"
              v-model="eb.marginType"
              @on-change="marginTypeChanged"
            >
              <Radio
                label="cross"
                :title="$text.tr('Риск всем депозитом')"
                class="futures-panel__margin-type"
              >CROSS</Radio>
              <Radio
                label="isolated"
                :title="$text.tr('Риск только залогом')"
                class="futures-panel__margin-type"
              >ISOLATED</Radio>
            </RadioGroup>
          </template>
        </div>
        </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('ЗАЛОГ') }}</td>
          <td class="value-cell" style="text-align: left;">
            {{ margin }}
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('СУММА') }}</td>
          <td class="value-cell">
            <i-input
              :disabled="bot.Stage === 'WAITSELL'"
              @on-change="amountChanged"
              size="small"
              :value="eb.amount"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr style="height: 35px;">
          <td
            colspan="2"
            style="text-align: left;"
          >
            <div
              v-if="bot.Stage !== 'WAITSELL'"
              style="margin-top: -15px;"
            >
              <span
                class="amount-percent"
                style="padding-left: 0px"
                @click="percentFromAmount(10)"
              >10%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(25)"
              >25%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(50)"
              >50%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(100)"
              >100%</span>
            </div>
          </td>
          <td>
            <Slider
              @on-input="sliderChanged"
              style="margin-top: -20px; height: 20px"
              :value="amountSlider"
              show-tip="never"
              :min="0"
              :max="maxAmount"
              :step="stepAmount"
            ></Slider>
          </td>
        </tr>
        <tr style="height: 35px;">
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('ЦЕНА МАКС') }}</td>
          <td class="value-cell">
            <i-input
              @on-change="saveNeeded = true"
              size="small"
              v-model="eb.maxPrice"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              {{ buyPriceErr }}
            </div>
          </td>
        </tr>
        <tr style="height: 35px;">
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('ЦЕНА МИН') }}</td>
          <td class="value-cell">
            <i-input
              size="small"
              v-model="eb.minPrice"
              @on-change="saveNeeded = true"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              {{ sellPriceErr }}
            </div>
          </td>
        </tr>
        <tr style="height: 35px;">
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('КОЛ-ВО') }}</td>
          <td class="value-cell">
            <i-input
              size="small"
              type="text"
              v-model="eb.gridsNum"
              @on-change="saveNeeded = true"
              @on-keydown="onkeyDown($event)"
            />
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('ПРИБЫЛЬ В') }} <Tooltip :delay="600" max-width="300" placement="right-start">
            <Icon style="color: var(--color-text-dark); vertical-align: center; padding-bottom: 1px;" size="14" type="ios-information-circle-outline"></Icon>
            <div slot="content">{{ $text.tr('Выберите, в какой валюте будет накапливаться прибыль — в базовом активе (в контракте) или в USDT.') }} <a
                  style="color: var(--color-accent-dark)"
                  target="_blank"
                  :href="$text.tr('https://doc.capico.app/ru/features/grid')"
              >{{ $text.tr('Подробнее') }}</a></div>
          </Tooltip></td>
          <td class="value-cell" style="text-align: left;">
            <RadioGroup
                type="button"
                size="small"
                v-model="eb.profitCollection"
                style="width: 100%; display: flex;"
              >
                <Radio label="COIN" style="flex: 1; text-align: center;">{{ baseAsset }}</Radio>
                <Radio label="USDT" style="flex: 1; text-align: center;">USDT</Radio>
              </RadioGroup>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              {{ sellPriceErr }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            style="height: 10px;"
          >
          </td>
        </tr>
        <!--      <tr>-->
        <!--        <td colspan="3">-->
        <!--          <Button :disabled="buttonDisable" @click="editBot()" size="small" long style="width: 100%; height: 30px">-->
        <!--            <div style="font-size: 12px">ЗАПУСТИТЬ БОТА</div>-->
        <!--          </Button>-->
        <!--        </td>-->
        <!--      </tr>-->
      </table>

      <!-- Grid Calculation Information -->
      <div
        v-if="gridInfo && Object.keys(gridInfo).length > 0"
        class="grid-info-panel"
        style="margin-top: 0px; padding: 5px; padding-bottom: 0px; border-radius: 5px; border: 1px solid var(--color-neutral-dark);"
      >
        <div class="grid-info-combined">
          <div class="grid-info-item" v-if="gridInfo.interval">
            <div class="grid-info-label">{{ $text.tr('ИНТЕРВАЛ') }}</div>
            <div class="grid-info-value">{{ gridInfo.interval }} {{ currency }}</div>
          </div>
          <div class="grid-info-item" v-if="gridInfo.intervalPct">
            <div class="grid-info-label">{{ $text.tr('ИНТЕРВАЛ') }} %</div>
            <div class="grid-info-value">{{ gridInfo.intervalPct }}</div>
          </div>
          <div class="grid-info-item" v-if="gridInfo.minInvest">
            <div class="grid-info-label">{{ $text.tr('МИН. СУММА') }}</div>
            <div class="grid-info-value">{{ gridInfo.minInvest }} {{ currency }}</div>
          </div>
        </div>
      </div>

      <!-- Simulation Panel -->
      <div
        v-if="gridInfo && Object.keys(gridInfo).length > 0"
        class="simulation-panel"
        style="margin-top: 5px; padding: 8px; border-radius: 5px; border: 1px solid var(--color-neutral-dark);"
      >
        <div class="sim-content">
          <div style="display: flex; align-items: start;">
          <Button
            @click="runSimulation"
            :loading="isSimulating"
            size="small"
            type="primary"
            :disabled="errormsg !== ''"
            style="margin-right: 5px; width: 100px;"
          >
            BACKTEST

          </Button>
          <Tooltip :delay="600" max-width="300" placement="right-start" :content="$text.tr('Backtest — это симуляция торговли по историческим данным за последние 30 дней. Показывает, сколько сделок мог бы совершить Grid-бот с текущими настройками, а также прибыль от работы сетки и APR. В расчёте учитываются комиссии, но точка входа не принимается во внимание.')">
              <Icon style="color: var(--color-text-dark); vertical-align: center; padding-bottom: 1px;" size="14" type="ios-information-circle-outline"></Icon>
          </Tooltip>
          </div>
          <div class="sim-info">
            <span class="sim-label">{{ $text.tr('СДЕЛОК') }}</span>
            <span class="sim-value">{{ simNum }}</span>
          </div>
          <div class="sim-info">
            <span class="sim-label">{{ $text.tr('ПРОФИТ') }}</span>
            <span class="sim-value" :class="{'sim-profit-positive': simProfit >= 0, 'sim-profit-negative': simProfit < 0}">{{ simProfit }}</span>
          </div>
          <div class="sim-info">
            <span class="sim-label">APR</span>
            <span class="sim-value" :class="{'sim-profit-positive': simAPR >= 0, 'sim-profit-negative': simAPR < 0}">{{ simAPR }}%</span>
          </div>
        </div>
      </div>

      <div style="height: 36px;">
        <div v-if="errormsg" class="err-text14">
          {{ errormsg }}
        </div>
        <div v-else-if="warningmsg" class="warn-text14">
          {{ warningmsg }}
        </div>
      </div>
      <div
        slot="footer"
        style="margin-top: auto; margin-bottom: 5px;"
      >
        <div style="display: flex; justify-content: space-between; align-content: flex-end">
          <Icon
            type="ios-close-circle-outline"
            size="30"
            style="cursor: pointer; padding-right: 50px"
            :title="$text.tr('Закрыть окно') + ' (ESC)'"
            class="clsbtn"
            @click="closeEditBot"
          />
          <Button
            :loading="loading"
            :disabled="errormsg !== ''"
            @click="saveClicked"
            size="small"
            long
            style="width: 100%; height: 30px"
          >
            <span style="font-size: 12px">{{ $text.tr(btnText) }}</span>
          </Button>
        </div>
        <!--      <table style="width: 100%; max-width: 570px">-->
        <!--        <tr>-->
        <!--          <td>-->
        <!--            <Button :loading="loading" :disabled="buttonDisable || !saveNeeded" @click="saveClicked" size="small" long style="width: 100%; height: 30px">-->
        <!--              <span style="font-size: 12px">{{ btnText }}</span>-->
        <!--            </Button>-->
        <!--          </td>-->
        <!--          <td style="width: 80px; text-align: right;">-->
        <!--            <Icon type="ios-close-circle-outline" size="30" style="cursor: pointer" class="clsbtn" @click="closeEditBot"/>-->
        <!--&lt;!&ndash;            <Button>&ndash;&gt;-->
        <!--&lt;!&ndash;              X&ndash;&gt;-->
        <!--&lt;!&ndash;            </Button>&ndash;&gt;-->
        <!--          </td>-->
        <!--        </tr>-->
        <!--      </table>-->

      </div>
    </div>

    <!--    </Modal>-->
  </div>
</template>

<script>
import SymbolsChooser from '@/components/common/SymbolsChooser.vue'
import Decimal from 'decimal.js'
import BotApi from '@/util/botapi'
import Grids from '@/services/grids'
import Util from '@/util/util'
import GridOrdersModal from './GridOrdersModal'
import CoinIcon from '@/components/common/CoinIcon.vue'
import Data from '@/util/data'
import terminal from '@/services/terminal'
import axios from 'axios'

const MAX_LEVERAGE = 25

export default {
  name: 'EditGrid',
  components: {
    GridOrdersModal,
    CoinIcon,
    SymbolsChooser
  },
  props: ['bot'],
  data () {
    return {
      headerText: this.$text.tr('НОВЫЙ GRID'),
      loading: false,
      buttonDisable: false,
      triggerPriceErr: '',
      sellPriceErr: '',
      buyPriceErr: '',
      amountErr: '',
      errormsg: '',
      warningmsg: '',
      inited: false,
      // sellPrice: '',
      // buyPrice: '',
      // amount: '',
      amountSlider: 0,
      amountRatio: 0,
      balance: 0,
      // slPrice: '',
      // triggerPrice: '',
      // autoLaunch: false,
      // trigger: false,
      // stopLoss: false,
      symbol: '',
      // botName: '',
      botId: '',
      saveNeeded: true,
      botOrders: [],
      botOrdersModalShow: false,
      gridInfo: {},
      simNum: 0,
      simProfit: 0,
      simAPR: 0,
      isSimulating: false,
      isConfirming: false,
      confirmationTimer: null
    }
  },
  watch: {
    margin () {
      this.checkErrors()
    },
    '$store.state.grids.editGrid': function (cmd) {
      if (cmd.editMode !== undefined) {
        this.eb.editMode = cmd.editMode
      }
      const prevSymbol = this.$store.state.grids.symbol
      if (cmd.symbol !== undefined) {
        Grids.SelectGridsSymbol(cmd.symbol)
      }
      if (!this.eb.editMode) {
        this.eb.minPrice = ''
        this.eb.maxPrice = ''
        return
      }
      this.inited = false
      let symbolChangedFinished = Promise.resolve()
      if (this.$store.state.grids.symbol !== prevSymbol || cmd.type === 'new') {
        this.updSymbol()
        symbolChangedFinished = this.symbolChanged(this.symbolUS)
      }
      Promise.all([symbolChangedFinished, Grids.UpdateGridsBalance()]).then(() => {
        const skipPricesUpdate = cmd.type === 'copy'
        this.updPrices(skipPricesUpdate)
        if (cmd.amount !== undefined) this.eb.amount = cmd.amount
        if (cmd.gridsNum !== undefined) this.eb.gridsNum = cmd.gridsNum
        if (cmd.profitCollection !== undefined) this.eb.profitCollection = cmd.profitCollection
        if (cmd.minPrice !== undefined) this.eb.minPrice = cmd.minPrice
        if (cmd.maxPrice !== undefined) this.eb.maxPrice = cmd.maxPrice
        this.inited = true
        this.checkErrors()
      })
    },
    'eb.amount': function () {
      this.updateGridInfo()
    },
    'eb.maxPrice': function () {
      this.updateGridInfo()
      this.checkErrors()
    },
    'eb.minPrice': function () {
      this.updateGridInfo()
      this.checkErrors()
    },
    'eb.gridsNum': function () {
      this.updateGridInfo()
      this.checkErrors()
    },
    'eb.profitCollection': function () {
      this.checkErrors()
    }
  },
  computed: {
    botSymbols () {
      if (this.$store.state.sys.tradeExchange.ExchId === 'FTX') {
        return this.$store.state.data.symbols.filter(symbol => {
          if (!symbol.baseAsset.includes('-')) {
            return true
          }
        })
      }
      return this.$store.state.data.symbols
    },
    balanceTrunc () {
      // return new Decimal(this.balance).toDecimalPlaces(2).toString()
      // console.log('freeBal', this.$store.state.grids.freeBal)
      if (this.$store.state.grids.freeBal === '') {
        return new Decimal(0)
      }
      return new Decimal(this.$store.state.grids.freeBal).toDP(2)
    },
    eb () {
      return this.$store.state.grids
    },
    stepAmount () {
      return 10
    },
    symbolUS () {
      return this.symbol.replace('/', '_')
    },
    currency () {
      return this.symbol.split('/')[1]
    },
    baseAsset () {
      return this.symbol.split('/')[0]
    },
    maxAmount () {
      return new Decimal(this.balance).mul(this.eb.leverage).toDP(0, Decimal.ROUND_DOWN).toNumber()
    },
    maxLeverage () {
      return MAX_LEVERAGE
    },
    margin () {
      try {
        return new Decimal(this.eb.amount).div(this.eb.leverage).toDP(2).toNumber()
      } catch {
        return 0
      }
    },
    btnText () {
      return this.isConfirming ? this.$text.tr('ПОДТВЕРДИТЬ?') : this.$text.tr('ЗАПУСТИТЬ НОВЫЙ GRID')
    }
  },
  beforeDestroy () {
    this.$store.commit('destroyModalObservers')
    // Clean up confirmation timer
    if (this.confirmationTimer) {
      clearTimeout(this.confirmationTimer)
      this.confirmationTimer = null
    }
  },
  created () {
    // this.updSymbol()
    // this.updPrices()
  },
  mounted () {
    this.$store.commit('setModalObservers', this.closeOnEsc)
    this.updSymbol()
    // Grids.UpdateGridsBalance().then(() => {
    //   this.updPrices()
    // })
    this.symbolChanged(this.symbolUS)
  },
  methods: {
    checkErrors () {
      if (!this.inited) {
        return
      }

      this.warningmsg = ''
      this.errormsg = ''

      if (!this.eb.amount) {
        return
      }
      if (!this.gridInfo.minInvest || !this.eb.maxPrice || !this.eb.minPrice || !this.eb.gridsNum) {
        this.errormsg = this.$text.tr('Ошибка')
        return
      }

      // Calculate min_profit and min_amount for warning check (only in COIN mode)
      if (this.eb.profitCollection === 'COIN') {
        try {
          const maxPrice = new Decimal(this.eb.maxPrice)
          const minPrice = new Decimal(this.eb.minPrice)
          const gridsNum = parseInt(this.eb.gridsNum)
          const amount = new Decimal(this.eb.amount)

          if (maxPrice.gt(minPrice) && gridsNum > 0) {
            const interval = maxPrice.minus(minPrice).div(gridsNum)

            // Get minQty calculation from symbolfilter
            const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
            if (filt) {
              const qtyDec = filt.QtyDec
              const qtyStep = new Decimal(1).div(new Decimal(10).pow(qtyDec))
              const minUsdt = new Decimal(5)
              const minQty = qtyStep

              // Calculate min_amount and min_profit
              const minAmount = maxPrice.minus(interval).mul(minQty).toDP(3)
              const minProfit = amount.div(gridsNum).div(maxPrice.minus(interval)).mul(interval).toDP(3)

              // Check if min_profit < min_amount
              if (minProfit.lt(minAmount)) {
                this.warningmsg = `profit: ${minProfit.toDP(8).toString()} < min_amount: ${minAmount.toDP(8).toString()}`
              }
            }
          }
        } catch (error) {
          console.error('Error calculating min_profit/min_amount:', error)
        }
      }

      // Regular error checks
      try {
        if (this.margin > this.balanceTrunc.toNumber()) {
          this.errormsg = this.$text.tr('Недостаточно средств')
        } else if (new Decimal(this.eb.amount).lt(this.gridInfo.minInvest)) {
          this.errormsg = this.$text.tr('Минимальная сумма: ') + this.gridInfo.minInvest
        } else if (new Decimal(this.eb.maxPrice).lt(new Decimal(this.eb.minPrice))) {
          this.errormsg = this.$text.tr('Ошибка')
        }
      } catch {
        this.errormsg = this.$text.tr('Ошибка')
      }
    },
    marginTypeChanged (marginType) {
      terminal.setMargin({ marginType, src: 'm', symbol: this.symbolUS, side: 'B' }).then(response => {
        if (!response.data) {
          return
        }

        if (response.data.err) {
          this.symbolChanged(this.symbolUS)
          return
        }

        this.$Notice.success({
          title:
            this.$text.tr('Тип маржи установлен: ') + marginType.toUpperCase(),
          duration: 3
        })
      })
    },
    leverageDragged (leverage) {
      if (!this.inited) return
      this.updateAmount({ amount: this.eb.amount, balance: this.balance, leverage })
      this.updateAmountRatio()
    },
    leverageChanged (leverage) {
      if (!this.inited) return
      this.updateAmount({ amount: this.eb.amount, balance: this.balance, leverage })
      const marginType = this.eb.marginType
      terminal
        .setMargin({ marginType, leverage, src: 'l', symbol: this.symbolUS, side: 'B' })
        .then(response => {
          if (!response.data) {
            return
          }

          if (response.data.err) {
            this.symbolChanged(this.symbolUS)
            return
          }

          this.$Notice.success({
            title: this.$text.tr('Плечо установлено: ') + leverage + 'X',
            duration: 3
          })
          Grids.UpdateGridsBalance()
          // this.$store.dispatch('updateTrades')
          // setTimeout(() => {
          // this.$store.dispatch('updateAssets')
          // this.$store.dispatch('updateAssetBalance', true)
          // }, 500)
        })
        .catch(() => {
          this.symbolChanged(this.symbolUS)
        })
    },
    symbolChanged (symbol) {
      // if (!this.$store.getters.isFutures) {
      //   return
      // }

      // this.applyOKXMarginType()
      return terminal.getMargin({ symbol, side: 'B' }).then(response => {
        if (!response.data || response.data.err) {
          return
        }

        // console.log(response.data)
        this.eb.marginType = response.data.MarginType
        this.eb.leverage = Decimal.min(MAX_LEVERAGE, Decimal.max(1, response.data.Leverage)).toNumber()
      })
    },
    updateAmountRatio () {
      if (this.maxAmount > 0) {
        this.amountRatio = new Decimal(this.eb.amount || 0).div(this.maxAmount).toNumber()
      }
    },
    updateAmount ({ amount, balance, leverage, oldBalance } = {}) {
      const balanceDec = new Decimal(balance || 0)
      const flooredMax = balanceDec.mul(leverage).toDP(0, Decimal.ROUND_DOWN)
      if (balanceDec.lte(0) || flooredMax.lte(0)) {
        return
      }
      const oldBalanceDec = new Decimal(oldBalance || 0)
      if (oldBalanceDec.gt(0) && !balanceDec.eq(oldBalanceDec)) {
        const ratio = Decimal.min(this.amountRatio, 1)
        const newAmount = flooredMax.mul(ratio).toDP(0, Decimal.ROUND_DOWN)
        this.eb.amount = newAmount.toString()
        this.amountSlider = newAmount.toNumber()
        return
      }
      if (new Decimal(this.amountSlider || 0).gt(flooredMax)) {
        this.amountSlider = flooredMax.toNumber()
      }
      const amountDec = new Decimal(amount || 0)
      if (amountDec.lte(0)) {
        return
      }
      if (amountDec.gt(flooredMax)) {
        this.eb.amount = flooredMax.toString()
        this.amountSlider = flooredMax.toNumber()
      }
    },
    leverageClicked (leverage) {
      this.eb.leverage = Decimal.min(MAX_LEVERAGE, Decimal.max(1, new Decimal(this.eb.leverage).add(leverage))).toNumber()
      this.updateAmount({ amount: this.eb.amount, balance: this.balance, leverage: this.eb.leverage })
      this.updateAmountRatio()
      const levsaved = this.eb.leverage
      setTimeout(() => {
        if (levsaved === this.eb.leverage) {
          this.leverageChanged(this.eb.leverage)
        }
      }, 500)
    },
    amountChanged (e) {
      // console.log('amountChanged', e)
      this.eb.amount = e.target.value
      const parsed = parseFloat(e.target.value)
      if (!isNaN(parsed)) {
        this.amountSlider = parsed
        this.updateAmountRatio()
      }
      // this.saveNeeded = true
    },
    closeOnEsc (event) {
      if (event.keyCode === 27) {
        this.closeEditBot()
      }
    },
    closeEditBot () {
      this.$store.state.grids.editGrid = { type: 'close', editMode: false }
      this.$store.state.grids.simTrades = []
    },
    disableButton (ref, value) {
      ref.loading = value
      ref.buttonDisable = value
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    updSymbol () {
      const assets = this.$store.state.grids.symbol.split('_')
      this.symbol = assets[0] + '/' + assets[1]
      // console.log('updSymbol', this.symbol)
    },
    selectSymbol (symbol) {
      this.$store.state.grids.editGrid = { symbol }
    },
    sliderChanged (value) {
      // console.log('slider changed ' + this.amountSlider)
      // this.saveNeeded = true
      this.amountSlider = value
      if (!this.eb.amount || new Decimal(value).sub(this.eb.amount).abs().gte(this.stepAmount)) {
        this.eb.amount = new Decimal(this.amountSlider).toString()
      }
      this.updateAmountRatio()
    },
    updPrices (skipPriceUpdate = false) {
      // console.log('last', this.$store.state.grids.lastPrice)
      // console.log('filter1', this.$store.state.data.symbolsfilter)
      const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
      if (!filt) {
        return
      }
      // console.log('freeBal', this.$store.state.grids.freeBal)

      const oldBalance = this.balance
      this.balance = parseFloat(this.$store.state.grids.freeBal)
      this.updateAmount({ amount: this.eb.amount, balance: this.balance, leverage: this.eb.leverage, oldBalance })

      if (skipPriceUpdate) {
        return
      }

      if (this.amountSlider === 0) {
        this.amountSlider = 10
      }

      const priceDec = filt.PriceDec
      if (this.$store.state.grids.lastPrice) {
        this.eb.minPrice = new Decimal(0.95)
          .mul(this.$store.state.grids.lastPrice)
          .toDP(priceDec)
          .toString()
        this.eb.maxPrice = new Decimal(1.05)
          .mul(this.$store.state.grids.lastPrice)
          .toDP(priceDec)
          .toString()
      }
    },
    percentFromAmount (percent) {
      // if (percent === 100) {
      //   this.eb.amount = this.balance.toString()
      //   this.amountSlider = parseFloat(this.balance.toString())
      //   // this.saveNeeded = true
      //   return
      // }
      // let filt = this.$store.state.data.symbolsfilter[this.eb.symbol]
      let newQty = new Decimal(this.balance).div(100).mul(this.eb.leverage).mul(percent)
      // if (filt) {
      newQty = newQty.toDP(0, Decimal.ROUND_DOWN)
      // }
      const newQtyStr = newQty.toDecimalPlaces(0).toString()
      this.eb.amount = newQtyStr
      this.amountSlider = parseFloat(newQtyStr)
      this.amountRatio = new Decimal(percent).div(100).toNumber()
      // this.saveNeeded = true
      // console.log('newQty ' + newQty.toString())
    },
    saveClicked () {
      // First click - show confirmation
      if (!this.isConfirming) {
        this.isConfirming = true

        // Set 5-second timer to revert to base state
        this.confirmationTimer = setTimeout(() => {
          this.isConfirming = false
          this.confirmationTimer = null
        }, 5000)

        return
      }

      // Second click within 5 seconds - execute action
      if (this.confirmationTimer) {
        clearTimeout(this.confirmationTimer)
        this.confirmationTimer = null
      }
      this.isConfirming = false

      // Execute original action
      this.disableButton(this, true)
      const ref = this
      Grids.SaveGrid().then(function (resp) {
        if (resp.data) {
          if (resp.data.err) {
            Data.vm.$Notice.error({
              title: Data.vm.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(resp.data.err),
              duration: 10
            })
            ref.disableButton(ref, false)
            return
          }
          Data.vm.$Message.success({
            content: ref.$text.tr('Grid запущен'),
            duration: 1
          })
          ref.disableButton(ref, false)
          ref.eb.gridsUpdated = Date.now()
          Grids.UpdateGridsBalance()
        }
      })
    },
    onkeyDown (e) {
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    },
    async runSimulation () {
      this.isSimulating = true

      try {
        // Validate parameters
        const maxPrice = new Decimal(this.eb.maxPrice || 0)
        const minPrice = new Decimal(this.eb.minPrice || 0)
        const gridsNum = parseInt(this.eb.gridsNum || 0)

        if (maxPrice.lte(0) || minPrice.lte(0) || gridsNum <= 0 || maxPrice.lte(minPrice)) {
          this.simNum = 0
          this.simProfit = 0
          this.simAPR = 0
          this.isSimulating = false
          return
        }

        // Get quantity decimal places from symbol filter
        const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
        if (!filt) {
          console.error('Symbol filter not found for:', this.symbolUS)
          this.simNum = 0
          this.simProfit = 0
          this.simAPR = 0
          this.isSimulating = false
          return
        }

        const qtyDec = filt.QtyDec
        const lotSize = filt.QtyMin

        // Calculate interval: (maxPrice - minPrice) / gridsNum
        const interval = maxPrice.minus(minPrice).div(gridsNum)

        // Prepare API parameters
        const params = {
          maxp: maxPrice.toString(),
          minp: minPrice.toString(),
          interval: interval.toString(),
          qty_dec: qtyDec,
          lot_size: lotSize,
          invested: this.eb.amount.toString(),
          symbol: this.baseAsset
        }

        // Make API request
        // const response = await axios.get('http://localhost:1920/backsim', { params })

        const response = await Grids.Backsim(params)

        if (response.data) {
          // Map response data to simulation properties
          this.simNum = response.data.trades.length || gridsNum
          this.simProfit = response.data.profit || 0

          // Calculate APR using custom formula: profit * 12 / margin * 100%
          if (this.margin > 0) {
            const profit = new Decimal(response.data.profit || 0)
            const margin = new Decimal(this.margin)
            this.simAPR = profit.mul(12).div(margin).mul(100).toDP(0).toNumber()
          } else {
            this.simAPR = 0
          }

          // Store simulation trades in Vuex store for GridTV component
          this.$store.state.grids.simTrades = response.data.trades || []
        } else {
          // Handle empty response
          this.simNum = 0
          this.simProfit = 0
          this.simAPR = 0
          this.$store.state.grids.simTrades = []
        }
      } catch (error) {
        console.error('Simulation API error:', error)
        this.simNum = 0
        this.simProfit = 0
        this.simAPR = 0
        this.$store.state.grids.simTrades = []
      }

      this.isSimulating = false
    },
    updateGridInfo () {
      if (!this.inited) {
        return
      }

      try {
        const maxPrice = new Decimal(this.eb.maxPrice || 0)
        const minPrice = new Decimal(this.eb.minPrice || 0)
        const gridsNum = parseInt(this.eb.gridsNum || 0)
        const amount = new Decimal(this.eb.amount || 0)

        if (maxPrice.lte(0) || minPrice.lte(0) || gridsNum <= 0 || maxPrice.lte(minPrice)) {
          this.gridInfo = {}
          return
        }

        const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
        if (!filt) {
          return
        }

        const priceDec = filt.PriceDec
        const qtyDec = filt.QtyDec

        // Calculate interval
        const interval = maxPrice.minus(minPrice).div(gridsNum).toDP(priceDec)

        if (interval.lte(0)) {
          this.gridInfo = {}
          return
        }

        // Lot size from exchange symbol data (e.g. 1000 for PEPE, 0.01 for BTC)
        const lotSize = new Decimal(filt.QtyMin)

        // Calculate minimum volume per order (5 USDT minimum)
        const minVolume = new Decimal(5)
        // Safety margin for min investment when grid price is above market price.
        // Accounts for orders filling at market price + slippage buffer.
        const MIN_INVEST_SAFETY_MARGIN = new Decimal('0.05')
        const MIN_INVEST_SAFETY_MULTIPLIER = new Decimal(1).plus(MIN_INVEST_SAFETY_MARGIN)
        const lastPrice = this.$store.state.grids.lastPrice
        if (!lastPrice || isNaN(lastPrice) || new Decimal(lastPrice).lte(0)) {
          throw new Error('market price unavailable')
        }
        const marketPrice = new Decimal(this.$store.state.grids.lastPrice)

        // Calculate prices and sum, and find min/max percentages
        let sump = new Decimal(0)
        let curMaxp = maxPrice
        let maxPct = new Decimal(0)
        let minPct = new Decimal(1000) // Large initial value
        let totalMinInvest = new Decimal(0)

        for (let n = 1; n <= gridsNum; n++) {
          const buyPrice = curMaxp.minus(interval)
          const pct = interval.div(buyPrice).mul(100).toDP(2)

          if (pct.gt(maxPct)) {
            maxPct = pct
          }
          if (pct.lt(minPct)) {
            minPct = pct
          }

          // When buy price is above market price, the order fills at market price,
          // so we need more quantity to meet min notional at the lower price.
          const effectiveMinVolume = buyPrice.gt(marketPrice)
            ? minVolume.mul(buyPrice).div(marketPrice).mul(MIN_INVEST_SAFETY_MULTIPLIER)
            : minVolume

          // Calculate min_qty for this specific price level
          // (raw / lot_size).floor() * lot_size + lot_size — matches backend
          const minQty = effectiveMinVolume
            .div(buyPrice)
            .div(lotSize).floor().mul(lotSize)
            .plus(lotSize)

          // Calculate min_volume for this order
          const minVolumeForThisOrder = minQty.mul(buyPrice)
          totalMinInvest = totalMinInvest.plus(minVolumeForThisOrder)

          sump = sump.plus(buyPrice)
          curMaxp = buyPrice
        }

        this.gridInfo = {
          interval: interval.toString(),
          intervalPct: `${minPct.toString()}% - ${maxPct.toString()}%`,
          minInvest: totalMinInvest.toDP(2, Decimal.ROUND_UP).toString()
        }
      } catch (error) {
        console.error('Error calculating grid info:', error)
        this.gridInfo = {}
      }
    }
  }
}
</script>
